import React, { useState } from 'react';
import { ForgotPasswordModal } from './AuthComponent';
import { useNavigate } from 'react-router';
import { UserApi } from '../../app/api/user.api';
import './Login.css';


export function Login() 
{

  const navigate = useNavigate();
  const user = UserApi();

  const [inputs, setInputs] = useState();
  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);


  const handleInputs = ( event ) => {
    const { name , value } =  event.target ;
    setInputs( { ...inputs, [name] : value   } ) ;
  }


  const handleSubmit = async ( event ) => {
    event.preventDefault();
    setStatus(0);
    setIsLoading(true);
    try {
        const {data} = await user.auth(inputs);
        
        if( data.success &&  ['saler', 'admin', 'topadmin'].includes(data.user.status) ){
            localStorage.setItem("token", data.token);
            navigate('/commandes-en-cours');
        }
        else{
            setStatus(-1);
            setMessage("Accès non autorisé à cette plateforme.");
        }
    } catch (err) { 
        setIsLoading(false);
        setStatus(-1);
        const response = err?.response?.data;

        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }       
    }
    finally {
        setIsLoading(false);
    } 
  } 

  return (
    <div className="login-container">
      <div className="login-wrapper">

        {/* Login Card */}
        <div className="login-card border">
          {/* Header */}
          <div className="login-header">
            <div className="logo-circle">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h1 className="login-title">Ortega Panel</h1>
            <p className="login-subtitle">Connectez-vous à votre compte</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="login-form">
            <div className="d-flex justify-content-center">
              {
                isLoading && (
                  <div className="d-flex justify-content-center mb-2"> 
                    <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                  </div>
                )
              }
              {
                status === -1 && (
                  <div className="alert alert-danger mb-3 small w-100"> { message } </div>  
                )
              }
            </div>
            {/* Email Input */}
            <div className="d-flex flex-column mb-2">
              <label className="small text-secondary mb-1 px-2" htmlFor="email">
                <i className="bi bi-envelope me-2"></i>
                Adresse Email
              </label>
              <input name="email" type="email" id="email"className="input-field" placeholder="votre.email@example.com" onChange={ handleInputs } required />
            </div>

            {/* Password Input */}
            <div className="d-flex flex-column mb-4">
              <label className="small text-secondary mb-1 px-2" htmlFor="password">
                <i className="bi bi-lock me-2"></i>
                Mot de passe
              </label>
              <div className="password-input-wrapper">
                <input name="password" type={showPassword ? 'text' : 'password'} id="password" className="input-field" placeholder="••••••••" onChange={ handleInputs } required />
                <button type="button" className="toggle-password-btn" onClick={ () => setShowPassword( ! showPassword) } title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} >
                  <i className={`bi bi-eye${!showPassword ? '-slash' : ''}`}></i>
                </button>
              </div>
            </div>

            {/* Login Button */}
            <button type="submit" className="btn btn-green py-2 w-100">
              <span>Connexion</span>
              <i className="bi bi-arrow-right ms-2"></i>
            </button>
          </form>

          {/* Forgot Password Link */}
          <div className="forgot-password-section">
            <button type="button" className="btn-forgot-password" onClick={() => setShowForgotModal(true)}>
              <i className="bi bi-question-circle me-2"></i>
              Mot de passe oublié ?
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="d-flex justify-content-center mt-4">
          <p className="text-secondary mt-2">
            © 2026 Ortega. Tous droits réservés.
          </p>
        </div>
      </div>

      {/* Forgot Password Modal */}
      <ForgotPasswordModal
        show={showForgotModal}
        onHide={() => setShowForgotModal(false)}
      />
    </div>
  );
}
